import type { FaireProductEntity } from "../../entity_types/product";

export const p_5n5sgycnsj: FaireProductEntity = {
  token: "p_5n5sgycnsj",
  type: "product",
  name: "I Smell Snow Sweatshirt, Stars Hollow Sweatshirt X026",
  brandToken: "b_m6tfqnk7qr",
  brandName: "MAYA TX",
  imageUrl:
    "https://cdn.faire.com/fastly/cd4b4a0558fc82267614174688f8d47eba1f4da13544bbbe29f04770bebf01dc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a9a2b6ff1eb0cf75a69d3645afa1048a61d1e1f3ac85dab26c29a64bbd894b2.png",
    "https://cdn.faire.com/fastly/4fa476f28f3b19e0db91d550eafbca12f86a24d7989944de8419547fe79aa22c.png",
    "https://cdn.faire.com/fastly/74e06a5aa9724b0486dea37f31027f7964a2baded8dd883929367c91fd36aec6.png",
    "https://cdn.faire.com/fastly/c38231391a36b54d93308cf1b62fe78ef5a56e2f0b30b996fff9cf59154ff38d.jpeg",
    "https://cdn.faire.com/fastly/3b7d8df8bf21e6af548dfded78129aaecb24c7991d7165b40d13e1b3f628ebaa.jpeg",
    "https://cdn.faire.com/fastly/c86dd4166c1890c85b569cbcf30af8432f5b1c565f9144a2ceb6d0cd1ab07038.png",
  ],
  priceDollars: 35.83,
  description:
    "💥💥💥Sweatshirt💥💥💥\n8 oz./yd² (US) 13.3 oz./L yd (CA), 50/50 cotton/polyester, 20 singles\nHeather Sport colors: 60/40 polyester/cotton\nSafety Green: Compliant with ANSI / ISEA 107\n2-end midweight fleece fabric\nClassic fit\nAir jet yarn for softer feel and reduced pilling\nDouble-needle stitching at shoulders, armholes, neck, waistband and cuffs\n1x1 rib with spandex for enhanced stretch and recovery\nTear away label\n\n💥💥💥Hoodie 💥💥💥\n8 oz./yd² (US) 13.5 oz./L yd (CA), 50/50 cotton/polyester, 20 singles\nHeather Sport colors: 40/60 cotton/polyester\nSafety Green: Compliant with ANSI / ISEA 107\n2-end midweight fleece fabric\nClassic fit\nAir jet yarn for softer feel and reduced pilling\nDouble-lined hood with color-matched drawcord\nDouble-needle stitching at shoulders, armholes, neck, waistband and cuffs\nFront pouch pocket\n1 x 1 rib with spandex for enhanced stretch and recovery\nTear away label",
  tags: [],
  msrpDollars: 45.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:43.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
